/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Yup from "yup";
import React, { useEffect, useMemo, useState } from "react";
import TagManager from "react-gtm-module";
import firebase from "services/firebase";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { FiMail } from "react-icons/fi";
import { Formik } from "formik";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTour } from "hooks/useTour";

import AccordionItens from "components/Religue/AccordionItens";
import ContainedButton from "components/layout/form/containedButton";
import Loading from "components/layout/loading";
import Navbar from "components/MI/Navbar";
import OutlinedButton from "components/layout/form/outlinedButton";
import TextField from "components/layout/form/textField";
import UserMenu from "components/layout/userMenuNew";
import ValvulaImg from "assets/images/valvula.jpeg";
import api from "services/api";
import {
  setUnitsList,
  toggleSelectedUnit,
} from "store/actions/select-unit-actions";

import TourBalloon from "components/NewTour/TourBallon";
import {
  Body,
  Button,
  Container,
  ContentButtons,
  ContentEditEmail,
  ContentField,
  Details,
  Field,
  FormContainer,
  FormEditIcon,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalContentInfosReligue,
  ModalFooter,
  ModalHeader,
  ModalStyle,
  StatusSuspension,
  StatusUnit,
  StatusUnitContent,
  Step,
} from "./styles";

const Religue = (): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [loadingSolicitCase, setLoadingSolicitCase] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [openModalTurnOff, setOpenModalTurnOff] = useState(false);
  const [_, setOpenModalWithLink] = useState(false);
  const [modalWithLink, setModalWithLink] = useState<any>();
  const [modalInfos, setModalInfos] = useState<any>();
  const [activeKey, setActiveKey] = useState<number>();
  const [email, setEmail] = useState("");
  const [buttonModalTurnOff, setButtonModalTurnOff] = useState("request");
  const [hasOverdue, setHasOverdue] = useState(false);
  const [loadingButtonValidateToken, setLoadingButtonValidateToken] =
    useState(false);
  const [suspensions, setSuspensions] = useState([]);
  const [reconnections, setReconnections] = useState([]);

  const { selectedUnit } = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const { showTour, setTourType, setSteps, tourStep, tourType } = useTour();

  useEffect(() => {
    (async () => {
      await requestUserInfo();
      if (!selectedUnit.hasCurrentHouseholder) {
        history.push("/portal");
      }
    })();
  }, [selectedUnit]);

  const validatorSchemaEmail = (): any =>
    Yup.object().shape({
      email: Yup.string()
        .required("É necessário digitar um e-mail")
        .email("E-mail inválido"),
    });

  const validatorSchemaToken = (): any =>
    Yup.object().shape({
      token: Yup.string()
        .required("É necessário digitar um token")
        .length(6, "Token inválido"),
    });

  const requestHasOverDue = async (): Promise<any> => {
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const document = localStorage.getItem("@UltragazEmpresarial:document");
    const { instanceId } = selectedUnit;

    try {
      const response = await api.get(
        `industrial/customer/v1/units-status?document=${document}?&instance-id=${instanceId}`,
        {
          headers,
        }
      );

      const { data } = response;

      setHasOverdue(data[0].overdueInvoicesCount > 1);
    } catch (err) {
      const { response } = err;
      toast.error(response?.data?.message);
    }
  };

  const requestUserInfo = async (): Promise<any> => {
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    try {
      const {
        data: { email: emailData },
      } = await api.get(`industrial/customer/v1/customers/me`, {
        headers,
      });
      if (emailData) {
        setEmail(emailData);
      } else {
        setButtonModalTurnOff("updateEmail");
      }
    } catch (err) {
      const { response } = err;
      toast.error(
        response?.data?.message || "Não foi possível obter o contato do usuário"
      );
      console.error(err);
    }
  };

  const insertTagManager = (code): any => {
    let event = "";

    switch (code) {
      case "inadimplente":
        event = "religue_solicitacao_inadimplente";
        break;
      case "201":
        event = "religue_solicitacao_solicitado";
        break;
      case "422.007":
        event = "religue_solicitacao_gas_liberado";
        break;
      case "422.008":
        event = "religue_solicitacao_medicao_remota";
        break;
      case "422.009":
        event = "religue_solicitacao_caso_religue_em_aberto";
        break;
      case "422.011":
        event = "religue_solicitacao_unidade_nao_esta";
        break;
      case "422.010":
        event = "religue_solicitacao_unidade_boletos_abertos";
        break;
      case "any":
        event =
          "religue_solicitacao_qualquer_outro_movito_diferente_dos_anteriores";
        break;
      default:
        event =
          "religue_solicitacao_qualquer_outro_movito_diferente_dos_anteriores";
        break;
    }

    firebase.analytics().logEvent(event, {
      customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
      selectedBase: localStorage.getItem("@UltragazEmpresarial:selectedBase"),
      userName: localStorage.getItem("@UltragazEmpresarial:userName"),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        event: {
          customerCode: localStorage.getItem(
            "@UltragazEmpresarial:customerCode"
          ),
          selectedBase: localStorage.getItem(
            "@UltragazEmpresarial:selectedBase"
          ),
          userName: localStorage.getItem("@UltragazEmpresarial:userName"),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        event: {
          customerCode: localStorage.getItem(
            "@UltragazEmpresarial:customerCode"
          ),
          selectedBase: localStorage.getItem(
            "@UltragazEmpresarial:selectedBase"
          ),
          userName: localStorage.getItem("@UltragazEmpresarial:userName"),
        },
      },
    });
  };

  const handleTrustSolicit = (): void => {
    requestPostRecconections(true);
    setOpenModal(false);
  };

  const openUlly = (): void => {
    const chatbotButton = document.querySelector("#hi-custom-widget") as any;
    if (chatbotButton) {
      chatbotButton.click();
    }
  };

  const handleModalInformations = (status): any => {
    switch (status) {
      case "201":
      case "422.011":
        return {
          messager: (
            <>
              <p>
                O religue foi solicitado e será efetivado em até 5 dias úteis
              </p>
              <span>Lembre-se</span>
              <ul>
                <li>
                  A taxa de religue de <b>R$60,00</b> será cobrada na próxima
                  fatura.
                </li>
                <li>
                  É importante que, no dia da visita, o responsável pela unidade
                  e/ou condomínio esteja no local para <b>liberar o acesso</b>{" "}
                  da nossa equipe técnica;
                </li>
                <li>
                  Para que o religue seja realizado no medidor correto, é
                  obrigatório que o{" "}
                  <b>número da unidade esteja visível e legível.</b> Caso a
                  equipe técnica encontre alguma divergência o religue não será
                  executado;
                </li>
                <li>
                  Para preservar a sua segurança, a nossa equipe técnica{" "}
                  <b>não liberará a válvula para a passagem do gás.</b> Com a
                  finalização da prestação do serviço, assim que possível,
                  verifique o registro &quot;abre e fecha&quot;, localizado no
                  seu medidor, e libere a passagem do gás;
                </li>
              </ul>
            </>
          ),
          backButton: true,
        };
      case "422.007":
        return {
          messager: (
            <>
              <p>
                Não foi possível realizar a solicitação de religue da sua
                unidade pois está com o fornecimento de gás ligado.
              </p>
              <p>
                <b>
                  Caso esteja sem gás, pedimos que verifique se a válvula de
                  &quot;abre e fecha&quot; está aberta pois
                </b>{" "}
                para preservar a sua segurança, a nossa equipe técnica a mantém
                fechada depois de um religamento.
              </p>
            </>
          ),
          uac: true,
          backButton: true,
        };
      case "422.008":
        return {
          messager: (
            <p>
              Para medição remota, precisamos que solicite o religue com a{" "}
              <a href="#" onClick={openUlly}>
                Ully
              </a>
            </p>
          ),
          backButton: true,
        };
      case "422.009":
        return {
          messager: (
            <>
              <p>
                Não foi possível realizar a solicitação de religue da sua
                unidade pois já há uma solicitação em andamento.
              </p>
              <p>
                <b>Data limite para execução do serviço: date</b>
              </p>
            </>
          ),
          uac: true,
          backButton: true,
        };
      case "422.010":
        return {
          messager: (
            <>
              <p>
                Confirma que deseja realizar o religue de fornecimento da sua
                unidade?
              </p>
              <p>
                <b>
                  Atenção: Sua unidade possui boleto(s) em aberto, se o
                  pagamento não for identificado em até 2 dias úteis a unidade
                  pode ser suspensa novamente.
                </b>
              </p>
              <ul>
                <li>
                  A taxa de religue de <b>R$60,00</b> será cobrada na próxima
                  fatura.
                </li>
                <li>
                  É importante que, no dia da visita, o responsável pela unidade
                  e/ou condomínio esteja no local para <b>liberar o acesso</b>{" "}
                  da nossa equipe técnica;
                </li>
                <li>
                  Para que o religue seja realizado no medidor correto, é
                  obrigatório que o{" "}
                  <b>número da unidade esteja visível e legível.</b> Caso a
                  equipe técnica encontre alguma divergência o religue não será
                  executado;
                </li>
                <li>
                  Para preservar a sua segurança, a nossa equipe técnica{" "}
                  <b>não liberará a válvula para a passagem do gás.</b> Com a
                  finalização da prestação do serviço, assim que possível,
                  verifique o registro &quot;abre e fecha&quot;, localizado no
                  seu medidor, e libere a passagem do gás;
                </li>
              </ul>
            </>
          ),
          cancelButton: true,
          okButtom: () => handleTrustSolicit(),
        };
      case "newRule":
        return {
          messager: (
            <p>
              A solicitação de religue será liberada após a regularização dos{" "}
              <b>boletos vencidos</b>
            </p>
          ),
          uac: true,
          backButton: true,
        };
      default:
        return {
          messager: `Não foi possível solicitar o religue. Tente novamente mais tarde.`,
          cancelButton: true,
          okButtom: () => setOpenModal(false),
        };
    }
  };

  const handleSolicitCase = async (reason): Promise<any> => {
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };
    const contactIdSf = localStorage.getItem(
      "@UltragazEmpresarial:contactIdSf"
    );
    const { instanceId, unitId } = selectedUnit;
    const { data: dataCusomersMe } = await api.get(
      `industrial/customer/v1/customers/me`,
      { headers }
    );
    const customerSiteId = dataCusomersMe?.customerAddresses?.find(
      (data) => data?.unitId === unitId
    )?.siteId;

    const bodyToken = {
      customerSiteId,
      instanceId,
      contactIdSf,
      reason,
    };

    try {
      await api.post(`industrial/case/v1/suspensions`, bodyToken, {
        headers,
      });
      setOpenModalTurnOff(false);
      setModalWithLink({
        open: true,
        description: (
          <p>
            {reason === "Bloqueio"
              ? "O bloqueio de fornecimento temporário foi solicitado e será efetivado em até 5 dias úteis!"
              : "O desligue de fornecimento por saída do imóvel foi solicitado e será efetivado em até 5 dias úteis!"}
          </p>
        ),
      });
    } catch (err) {
      const {
        response: { data },
      } = err;
      setOpenModalTurnOff(false);
      setModalWithLink({
        open: true,
        description: <p>{data?.message}</p>,
      });
    }
  };

  const requestPostRecconections = async (trusted): Promise<any> => {
    setButtonLoading(true);

    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const document = localStorage.getItem("@UltragazEmpresarial:document");
    try {
      const { instanceId } = selectedUnit;
      await api.post(
        `industrial/case/v1/reconnections`,
        {
          document,
          trusted,
          unitInstanceId: instanceId,
        },
        { headers }
      );
      if (trusted) {
        setOpenModalWithLink(true);
        insertTagManager("inadimplente");
      } else {
        setModalInfos(handleModalInformations("201"));
        setOpenModal(true);
        insertTagManager("201");
      }
    } catch (error) {
      if (error.response) {
        const { response } = error;
        const { data } = response;
        const code = data.code || "any";
        setModalInfos(handleModalInformations(code));
        setOpenModal(true);
        insertTagManager(code);
      } else {
        setModalInfos(handleModalInformations("any"));
        setOpenModal(true);
        insertTagManager("any");
      }
    }

    await requestGetRecconections();
    await requestGetSuspensions();
    setButtonLoading(false);
  };

  const handleSolicit = (): any => {
    firebase.analytics().logEvent("religue_abrir_solicitacao", {
      customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
      selectedBase: localStorage.getItem("@UltragazEmpresarial:selectedBase"),
      userName: localStorage.getItem("@UltragazEmpresarial:userName"),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        religue_abrir_solicitacao: {
          customerCode: localStorage.getItem(
            "@UltragazEmpresarial:customerCode"
          ),
          selectedBase: localStorage.getItem(
            "@UltragazEmpresarial:selectedBase"
          ),
          userName: localStorage.getItem("@UltragazEmpresarial:userName"),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        religue_abrir_solicitacao: {
          customerCode: localStorage.getItem(
            "@UltragazEmpresarial:customerCode"
          ),
          selectedBase: localStorage.getItem(
            "@UltragazEmpresarial:selectedBase"
          ),
          userName: localStorage.getItem("@UltragazEmpresarial:userName"),
        },
      },
    });

    if (hasOverdue) {
      setModalInfos(handleModalInformations("newRule"));
      setOpenModal(true);
      return;
    }

    requestPostRecconections(false);
  };

  const renderBannerStatus = useMemo(() => {
    const statusArray = [...reconnections, ...suspensions];
    const { status: statusUnit } = selectedUnit;

    if (statusArray?.length) {
      const status = statusArray
        ?.filter((data) => data?.createdDate)
        ?.sort((a, b) => {
          // @ts-ignore
          return new Date(b?.createdDate) - new Date(a?.createdDate);
        })[0];

      let text = "";

      switch (status?.subject) {
        case "Religue":
        case "Ligue":
          text = "LIGUE";
          break;
        default:
          text = "SUSPENSÃO";
          break;
      }

      if (
        status &&
        ((status.subject !== "Religue" && statusUnit === "ON") ||
          (status.subject === "Religue" && statusUnit !== "ON"))
      ) {
        return (
          <StatusSuspension>
            <AiOutlineInfoCircle />
            <span>
              {`Há uma solicitação de ${text} de sua unidade em andamento.`}
            </span>
          </StatusSuspension>
        );
      }
    }

    return false;
  }, [reconnections, suspensions]);

  const sendToken = async (value): Promise<any> => {
    const userId = localStorage.getItem("@UltragazEmpresarial:userId");
    const siteId = localStorage.getItem("@UltragazEmpresarial:customerSiteId");
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const bodyContact = {
      contact: value,
      contactType: "EMAIL",
      siteId,
    };

    try {
      const createContact = await api.post(
        `industrial/customer/v1/users/${userId}/contacts`,
        bodyContact,
        {
          headers,
        }
      );

      const contactId = createContact.headers.location.split("/").pop();

      const bodyToken = {
        contactId,
        tokenType: "REGISTER",
      };

      const responseToken = await api.post(
        `industrial/customer/v1/users/${userId}/tokens`,
        bodyToken,
        {
          headers,
        }
      );

      toast.warn(`Enviamos um código de verificação para ${value}`);
      return responseToken;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Ocorreu um erro interno na aplicação"
      );
      return false;
    }
  };

  const validationToken = async (token, email): Promise<any> => {
    const userId = localStorage.getItem("@UltragazEmpresarial:userId");
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const bodyToken = {
      token,
    };

    let success;
    try {
      await api.post(
        `industrial/customer/v1/users/${userId}/validations`,
        bodyToken,
        {
          headers,
        }
      );
      success = true;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ?? "Ocorreu um erro interno na aplicação"
      );
      success = false;
    }

    return success;
  };

  const handleSolicitBlocked = async (): Promise<any> => {
    setLoadingSolicitCase(true);
    await handleSolicitCase("Bloqueio");
    await requestGetRecconections();
    await requestGetSuspensions();
    setLoadingSolicitCase(false);
  };

  const handleSolicitTurnOff = async (): Promise<any> => {
    setLoadingSolicitCase(true);
    await handleSolicitCase("Fechamento");

    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const body = {
      deliveryType: "EMAIL",
    };

    try {
      await api.patch(
        `industrial/customer/v1/customers/me/units/${selectedUnit.unitId}`,
        body,
        {
          headers,
        }
      );
      const response = await api.get(
        `industrial/customer/v1/customers/me/units`,
        { headers }
      );
      const { data } = response;
      dispatch(setUnitsList(data));
      const { instanceId } = selectedUnit;
      const unitFilted = data.find((unit) => instanceId === unit.instanceId);
      if (unitFilted) {
        dispatch(toggleSelectedUnit(unitFilted));
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Ocorreu um erro interno na aplicação"
      );
    }

    setOpenModalTurnOff(false);
    await requestGetRecconections();
    await requestGetSuspensions();
    setLoadingSolicitCase(false);
  };

  const getDay = (n): string => (n < 10 ? `0${n}` : n);

  const requestGetSuspensions = async (): Promise<void> => {
    const document = localStorage.getItem("@UltragazEmpresarial:document");
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };
    const { unitId } = selectedUnit;
    const { data: dataCusomersMe } = await api.get(
      `industrial/customer/v1/customers/me`,
      { headers }
    );
    const customerSiteId = dataCusomersMe?.customerAddresses?.find(
      (data) => data?.unitId === unitId
    )?.siteId;

    const dateBegin = new Date();
    dateBegin.setDate(dateBegin.getDate() - 4);
    const yearBegin = dateBegin.getFullYear();
    const monthBegin = getDay(dateBegin.getMonth() + 1);
    const dayBegin = getDay(dateBegin.getDate());

    const dateEnd = new Date();
    const yearEnd = dateEnd.getFullYear();
    const monthEnd = getDay(dateEnd.getMonth() + 1);
    const dayEnd = getDay(dateEnd.getDate());

    const params = {
      "customer-site-id": customerSiteId,
      document,
      "begin-date": `${yearBegin}-${monthBegin}-${dayBegin}`,
      "end-date": `${yearEnd}-${monthEnd}-${dayEnd}`,
    };

    try {
      const response = await api.get(`industrial/case/v1/suspensions`, {
        headers,
        params,
      });

      const { data } = response;
      setSuspensions(data);
    } catch (error) {
      const { response } = error;
      toast.error(
        response?.data?.message || "Não foi possível obter as suspensões"
      );
    }
  };

  const requestGetRecconections = async (): Promise<void> => {
    const dateBegin = new Date();
    dateBegin.setDate(dateBegin.getDate() - 4);
    const yearBegin = dateBegin.getFullYear();
    const monthBegin = getDay(dateBegin.getMonth() + 1);
    const dayBegin = getDay(dateBegin.getDate());

    const dateEnd = new Date();
    const yearEnd = dateEnd.getFullYear();
    const monthEnd = getDay(dateEnd.getMonth() + 1);
    const dayEnd = getDay(dateEnd.getDate());

    const document = localStorage.getItem("@UltragazEmpresarial:document");

    const { instanceId } = selectedUnit;

    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const params = {
      "unit-instance-id": instanceId,
      document,
      "begin-date": `${yearBegin}-${monthBegin}-${dayBegin}`,
      "end-date": `${yearEnd}-${monthEnd}-${dayEnd}`,
    };

    try {
      const response = await api.get(`industrial/case/v1/reconnections`, {
        headers,
        params,
      });

      const { data } = response;
      setReconnections(data);
    } catch (err) {
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      await requestGetRecconections();
      await requestGetSuspensions();
      await requestHasOverDue();
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    setTourType("religue");
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  return (
    <Navbar selected="religue">
      <UserMenu breadcrump={null} intro />
      <Container
        showTour={tourStep === 1 && tourType === "religue" && showTour}
      >
        <Header>
          <HeaderInfos>
            <HeaderTitle>Ligar e desligar gás</HeaderTitle>
            <HeaderSubtitle>
              Com alguns cliques você liga e desliga o gás da sua unidade.
              Entenda os detalhes:
            </HeaderSubtitle>
          </HeaderInfos>
        </Header>
        <Body>
          <Details>
            <StatusUnitContent>
              <StatusUnit
                status={selectedUnit?.status === "ON" ? "on" : "off"}
              />
              Sua unidade está com o gás{" "}
              {selectedUnit?.status === "ON" ? "ligado" : "desligado"}
            </StatusUnitContent>
            {renderBannerStatus}
          </Details>
          <AccordionItens
            activeKey={activeKey}
            setActiveKey={(key) => setActiveKey(key === activeKey ? null : key)}
            items={[
              {
                title: "Solicitar desligue de fornecimento por saída do imóvel",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      Ao sair do seu imóvel é preciso que solicite o{" "}
                      <b>desligamento do gás</b> ou que o novo morador da
                      unidade faça o primeiro acesso ao Portal Minha UItragaz. O
                      desligamento da sua unidade encerra o serviço prestado em
                      seu nome.
                    </p>

                    <span>Como reverter o serviço?</span>
                    <p>
                      Para retomar o consumo o novo morador deverá realizar o
                      primeiro acesso no portal e a ligação da unidade será
                      executada em até 5 dias úteis.
                    </p>

                    <span>O serviço é cobrado?</span>
                    <p>
                      Não há custo para{" "}
                      <a href="#" onClick={() => setActiveKey(1)}>
                        &quot;Desligue por saída do imóvel&quot;
                      </a>{" "}
                      ou{" "}
                      <a href="#" onClick={() => setActiveKey(2)}>
                        &quot;Ligação de fornecimento da unidade de um novo
                        morador&quot;
                      </a>
                      .
                    </p>

                    <ContentButtons>
                      <ContainedButton
                        disabled={
                          suspensions?.length > 0 ||
                          loadingSolicitCase ||
                          selectedUnit?.status !== "ON"
                        }
                        loading={buttonLoading || loadingSolicitCase}
                        onClick={() => setOpenModalTurnOff(true)}
                      >
                        Solicitar
                      </ContainedButton>
                    </ContentButtons>
                  </>
                ),
              },
              {
                title: "Ligação de fornecimento da unidade de um novo morador",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      Após realizar o primeiro acesso ao portal, a ligação de
                      fornecimento da unidade será solicitado automaticamente.
                      Para realizar o ligue de uma nova unidade que ainda não
                      está em seu nome,{" "}
                      <a href="/adicionar-unidade">
                        &quot;Adicione nova unidade&quot;
                      </a>{" "}
                      , e será solicitado automaticamente.
                    </p>
                    <p>
                      Para retomar uma unidade que já esteve em seu nome, por
                      favor, entre em contato com o atendimento:
                    </p>
                    <p>
                      <span>Regiões Metropolitanas: 4003-1616</span>
                      <span>Demais regiões: 0800-886-1616</span>
                    </p>

                    <span>Como reverter o serviço?</span>
                    <a href="#" onClick={() => setActiveKey(1)}>
                      Solicitar desligue de fornecimento por saída do imóvel
                    </a>
                    <a href="#" onClick={() => setActiveKey(5)}>
                      Solicitar bloqueio de fornecimento temporário
                    </a>

                    <span>O serviço é cobrado?</span>
                    <p>
                      Não há custo para &quot;Ligação da unidade de um novo
                      morador&quot;
                    </p>
                  </>
                ),
              },
              {
                title: "Bloqueio de fornecimento por inadimplência",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      É realizado pela Ultragaz quando um boleto está vencido a
                      mais de 20 dias corridos contando a partir da data de
                      vencimento.
                    </p>

                    <span>Como reverter o serviço?</span>
                    <p>
                      Após a compensação bancária do pagamento do boleto
                      (aproximadamente 3 dias úteis) a ordem de religue é
                      realizada automaticamente em até 2 dias úteis.
                    </p>
                    <p>
                      Se o pagamento já foi realizado você pode{" "}
                      <a href="#" onClick={() => setActiveKey(4)}>
                        Solicitar o religue de fornecimento.
                      </a>
                    </p>

                    <span>O serviço é cobrado?</span>
                    <p>
                      Não há custo para &quot;Bloqueio de fornecimento por
                      inadimplência&quot;, mas para o serviço de{" "}
                      <a href="#" onClick={() => setActiveKey(4)}>
                        Religue de fornecimento
                      </a>{" "}
                      será cobrado R$60,00 no boleto seguinte a execução do
                      serviço.
                    </p>
                  </>
                ),
              },
              {
                title: "Solicitar o religue de fornecimento",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      Quando desejar ligar a unidade que teve &quot;Bloqueio de
                      fornecimento por inadimplência&quot; ou solicitado o
                      &quot;Bloqueio de fornecimento temporário&quot;.
                    </p>
                    <p>
                      Após reconhecimento do pagamento, o prazo para religação
                      do seu gás é de até <b>2 dias úteis</b>.
                    </p>
                    <span>Como reverter o serviço?</span>
                    <a href="#" onClick={() => setActiveKey(5)}>
                      Bloqueio de fornecimento temporário
                    </a>
                    <a href="#" onClick={() => setActiveKey(1)}>
                      Solicitar desligue de fornecimento por saída do imóvel
                    </a>

                    <span>O serviço é cobrado?</span>
                    <p>Será cobrado o valor de R$60,00 no próximo boleto.</p>

                    <span>Observações adicionais:</span>
                    <ul>
                      <li>
                        Verifique se há algum boleto pendente de pagamento. Caso
                        seja identificado, gere aqui mesmo, pelo Portal Minha
                        Ultragaz, a 2ª via do seu boleto e realize o pagamento
                        imediatamente;
                      </li>
                      <li>
                        É importante que, no dia da visita, o responsável pela
                        unidade e/ou condomínio estejam no local para liberar o
                        acesso da nossa equipe técnica;
                      </li>
                      <li>
                        Para que o religue seja realizado no medidor correto, é
                        obrigatório que o número da unidade esteja visível e
                        legível. Caso a equipe técnica encontre alguma
                        divergência o religue não será executado;
                      </li>
                      <li>
                        Medidores com avarias, tais como: Ilegibilidade, visor
                        embaçado ou falta de proteção, não poderão ser
                        religados. Nesses casos, será necessária a substituição
                        do equipamento por um novo. Temos fornecedores
                        homologados que poderão lhe auxiliar, pergunte para a
                        Ully.
                      </li>
                      <li>
                        Para preservar a sua segurança, a nossa equipe técnica
                        não liberará a válvula para a passagem do gás. Com a
                        finalização da prestação do serviço, assim que possível,
                        verifique o{" "}
                        <a href="#" onClick={() => setOpenModalInfo(true)}>
                          registro &quot;abre e fecha&quot;
                        </a>
                        , localizado no seu medidor, e libere a passagem do gás;
                      </li>
                    </ul>
                    <ContentButtons>
                      <ContainedButton
                        disabled={reconnections.length > 0}
                        loading={buttonLoading}
                        onClick={handleSolicit}
                      >
                        Solicitar
                      </ContainedButton>
                    </ContentButtons>
                  </>
                ),
              },
              {
                title: "Solicitar bloqueio de fornecimento temporário",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      Quando desejar bloquear o fornecimento de gás da sua
                      unidade por motivo de viagem ou obras, e depois retomá-lo
                      em seu nome.
                    </p>
                    <p>
                      Atenção: Para solicitar este serviço é necessária a
                      adimplência com a Ultragaz. Por favor, verifique se há{" "}
                      <a href="/boletos">boletos</a> em aberto e realize o
                      pagamento antes de solicitar o bloqueio de fornecimento
                      temporário.
                    </p>

                    <span>Como reverter o serviço?</span>
                    <p>
                      <a href="#" onClick={() => setActiveKey(4)}>
                        Solicitar o religue de fornecimento
                      </a>
                    </p>

                    <span>O serviço é cobrado?</span>
                    <p>
                      Não é cobrado o serviço de &quot;Bloqueio de fornecimento
                      temporário&quot; mas para o serviço de &quot;Religue de
                      fornecimento&quot; será cobrado R$60,00 no boleto seguinte
                      a execução do serviço.
                    </p>

                    <ContentButtons>
                      <ContainedButton
                        disabled={
                          suspensions?.length > 0 ||
                          loadingSolicitCase ||
                          selectedUnit?.status !== "ON"
                        }
                        loading={buttonLoading || loadingSolicitCase}
                        onClick={handleSolicitBlocked}
                      >
                        Solicitar
                      </ContainedButton>
                    </ContentButtons>
                  </>
                ),
              },
            ]}
          />
        </Body>
        {showTour && tourStep === 1 && tourType === "religue" && (
          <TourBalloon
            title="Ligar e desligar gás"
            content="Aqui você consulta qual o status do gás em sua unidade. Com alguns cliques você pode ligar e desligar o gás. Entenda os detalhes!"
            position={{
              left: "50%",
              top: "45px",
              arrowPosition: "unset",
              maxWidth: 320,
              boxShadow: true,
            }}
          />
        )}
      </Container>

      {/* Modal de solicitação de desligue de fornecimento */}
      <ModalStyle show={openModalTurnOff} centered animation={false}>
        <ModalContainer>
          <ModalHeader>
            <div className="wrapper">
              <span>
                Solicitar desligue de fornecimento por saída do imóvel
              </span>
            </div>
            <MdClose size={24} onClick={() => setOpenModalTurnOff(false)} />
          </ModalHeader>
          <ModalBody>
            <ModalContent>
              <div>
                <p>
                  Tem certeza que deseja{" "}
                  <b>encerrar o serviço de abastecimento da sua unidade?</b>
                </p>
                <p>Veja como funciona:</p>

                <Step>
                  <div>
                    <span>1</span>
                    <p>Solicitar desligue de fornecimento no portal</p>
                  </div>
                  <div>
                    <span>2</span>
                    <p>
                      Em até 3 dias úteis é feita a suspensão do fornecimento e
                      última leitura
                    </p>
                  </div>
                  <div>
                    <span>3</span>
                    <p>Desvinculação da unidade do CPF</p>
                  </div>
                  <div>
                    <span>4</span>
                    <p>Geração do boleto com consumo residual e pagamento</p>
                  </div>
                </Step>

                <p>
                  Para o envio do <b>boleto residual</b> precisamos que confirme
                  seu <b>e-mail:</b>
                </p>
                {buttonModalTurnOff === "request" && (
                  <ContentEditEmail>
                    <span>E-mail cadastrado: {email}</span>
                    <Button
                      onClick={() => setButtonModalTurnOff("updateEmail")}
                    >
                      <FormEditIcon />
                      <span>Editar e-mail</span>
                    </Button>
                  </ContentEditEmail>
                )}
                {buttonModalTurnOff === "updateEmail" && (
                  <Formik
                    initialValues={{
                      email: email || "",
                    }}
                    onSubmit={async ({ email: emailData }) => {
                      setLoadingButtonValidateToken(true);
                      const result = await sendToken(emailData);
                      if (result) {
                        setButtonModalTurnOff("validateToken");
                        setEmail(emailData);
                      }
                      setLoadingButtonValidateToken(false);
                    }}
                    validationSchema={validatorSchemaEmail}
                    render={({
                      handleChange,
                      handleBlur,
                      values,
                      errors,
                      touched,
                    }) => (
                      <FormContainer>
                        <ContentField>
                          <Field>
                            <TextField
                              LeadingIcon={FiMail}
                              propsLeadingIcon={{
                                size: 24,
                              }}
                              type="text"
                              name="email"
                              label="Email *"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              errorCondition={errors.email && touched.email}
                              errorMessage={errors.email}
                              disabled={loading}
                            />
                          </Field>
                          <ContainedButton
                            type="submit"
                            disabled={
                              !values.email || loadingButtonValidateToken
                            }
                            loading={loadingButtonValidateToken}
                          >
                            Validar e-mail
                          </ContainedButton>
                        </ContentField>
                      </FormContainer>
                    )}
                  />
                )}
                {buttonModalTurnOff === "validateToken" && (
                  <Formik
                    initialValues={{
                      token: "",
                    }}
                    onSubmit={async ({ token }) => {
                      setLoadingButtonValidateToken(true);
                      const result = await validationToken(token, email);
                      if (result) {
                        setButtonModalTurnOff("request");
                      }
                      setLoadingButtonValidateToken(false);
                    }}
                    validationSchema={validatorSchemaToken}
                    render={({
                      handleChange,
                      handleBlur,
                      values,
                      errors,
                      touched,
                    }) => (
                      <FormContainer>
                        <ContentField>
                          <Field>
                            <TextField
                              LeadingIcon={FiMail}
                              propsLeadingIcon={{
                                size: 24,
                              }}
                              type="text"
                              name="token"
                              label="Token *"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.token}
                              errorCondition={errors.token && touched.token}
                              errorMessage={errors.token}
                              disabled={loading}
                            />
                          </Field>
                          <ContainedButton
                            type="submit"
                            disabled={
                              !values.token ||
                              values.token?.length !== 6 ||
                              loadingButtonValidateToken
                            }
                            loading={loadingButtonValidateToken}
                          >
                            Validar token
                          </ContainedButton>
                        </ContentField>
                      </FormContainer>
                    )}
                  />
                )}

                <p>
                  Fique tranquilo! O boleto também estará disponível aqui no
                  Portal Minha Ultragaz e nos demais canais digitais.
                </p>
              </div>
            </ModalContent>
          </ModalBody>
          <ModalFooter>
            <ContainedButton
              loading={loadingSolicitCase}
              disabled={buttonModalTurnOff !== "request" || loadingSolicitCase}
              onClick={() => handleSolicitTurnOff()}
            >
              Solicitar
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      {/* Modal de infomativo das solicitações */}
      <ModalStyle show={openModal} centered animation={false}>
        <ModalContainer>
          <ModalHeader>
            <div className="wrapper">
              <span>Solicitar o Religue de fornecimento</span>
            </div>
            <MdClose size={24} onClick={() => setOpenModal(false)} />
          </ModalHeader>
          <ModalBody>
            <ModalContent>
              <div>{modalInfos?.messager}</div>
            </ModalContent>
            {modalInfos?.uac && (
              <p>
                Ainda com dúvidas?{" "}
                <a href="#" onClick={() => openUlly()}>
                  Converse com a Ully
                </a>
              </p>
            )}
          </ModalBody>
          <ModalFooter>
            {modalInfos?.cancelButton && (
              <OutlinedButton onClick={() => setOpenModal(false)}>
                Cancelar
              </OutlinedButton>
            )}
            {modalInfos?.okButtom && (
              <ContainedButton onClick={() => modalInfos.okButtom()}>
                Ok
              </ContainedButton>
            )}
            {modalInfos?.backButton && (
              <ContainedButton
                width="min(280px, 90vw) !important; margin: auto;"
                onClick={() => setOpenModal(false)}
              >
                Voltar
              </ContainedButton>
            )}
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      {/* Modal de confirmação de solicitação o religue */}
      <ModalStyle show={modalWithLink?.open} centered animation={false}>
        <ModalContainer>
          <ModalHeader>
            <div className="wrapper">
              <span>Status da sua solicitação:</span>
            </div>
            <MdClose
              size={24}
              onClick={() =>
                setModalWithLink((prev) => ({
                  ...prev,
                  open: false,
                }))
              }
            />
          </ModalHeader>
          <ModalBody>
            <ModalContent>{modalWithLink?.description}</ModalContent>
          </ModalBody>
          <ModalFooter>
            <ContainedButton
              onClick={() =>
                setModalWithLink((prev) => ({
                  ...prev,
                  open: false,
                }))
              }
            >
              Ok
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      {/* Modal de infos do religue */}
      <ModalStyle show={openModalInfo} centered animation={false}>
        <ModalContainer>
          <ModalHeader>
            <div className="wrapper">
              {/* <span>Status da sua solicitação:</span> */}
            </div>
            <MdClose
              size={24}
              onClick={() =>
                setModalWithLink((prev) => ({
                  ...prev,
                  open: false,
                }))
              }
            />
          </ModalHeader>
          <ModalBody>
            <ModalContent>
              <ModalContentInfosReligue>
                <p>
                  Ao religar/ligar o seu gás, tomamos o cuidado de manter a
                  válvula fechada para que caso alguma unidade de consumo esteja
                  aberta (boca do fogão, forno...) não ocorra vazamento.
                </p>
                <p>Para liberar, gire a válvula conforme imagem:</p>
                <img src={ValvulaImg} alt="Válvula" />
              </ModalContentInfosReligue>
            </ModalContent>
          </ModalBody>
          <ModalFooter isNotButtonFull>
            <ContainedButton
              width="260px"
              onClick={() => setOpenModalInfo(false)}
            >
              Ok
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>
      {loading && <Loading />}
    </Navbar>
  );
};

export default Religue;
